import * as React from 'react';
import { Card } from "react-bootstrap";
import './ChangeBankingDetails.css';

interface State {
    bankingDetails: {
        bankName: string;
        branchCode: string;
        accountType: string;
        accountNumber: string;
    }
}

export interface ChangeBankingDetailsProps {
    saving?: boolean;
    success?: boolean;
    error?: any;
    premium: string;
    emitHandleConfirm;
    emitHandleBack;
    disableForm?: boolean;
    formComponent: any;
    footerComponent;
}

export class ChangeBankingDetails extends React.Component<ChangeBankingDetailsProps,State> {
    constructor(props: ChangeBankingDetailsProps) {
        super(props);
    }

    handleBack() {
        this.props.emitHandleBack();
    }
    
    public render() {
        return (
            <>
                <Card className="change-banking-details">
                    <Card.Header className="change-banking-details__header">
                        <Card.Title className="change-banking-details__title">
                            <h2>Change banking details</h2>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="change-banking-details__form row noma">
                            {this.props.formComponent}
                        </div>
                        <hr className="noma nopa change-banking-details__hr" />
                        { this.props.footerComponent }
                    </Card.Body>
                </Card>
            </>
        )
    }
}